import React, { useEffect, useRef } from "react";
import * as THREE from "three";
interface Props {
  className: string;
}
const HomeBackground: React.FC<Props> = (props) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    let isRunning = true;

    // Variables and Three.js setup
    const stageWidth = window.innerWidth;
    const stageHeight = window.innerHeight;
    const xRows = 25;
    const zRows = 25;
    const cubeSize = 600;
    const cubeGap = 200;
    const cubeRow = cubeSize + cubeGap;
    const cubes: THREE.Mesh[][] = [];

    const halfXRows = (cubeRow * -xRows) / 2;
    const halfZRows = (cubeRow * -zRows) / 2;

    const scene = new THREE.Scene();
    scene.fog = new THREE.Fog(0x000000, 5000, 10000);

    const camera = new THREE.PerspectiveCamera(
      55,
      stageWidth / stageHeight,
      1,
      20000
    );
    camera.position.y = 5000;
    camera.lookAt(new THREE.Vector3(0, 0, 0));

    // const pointLight = new THREE.PointLight(0xff4040);
    // pointLight.position.set(0, 1800, -1800);
    // scene.add(pointLight);
    // Light setup
    const pointLight = new THREE.PointLight(0xc0c0f0);
    pointLight.position.set(0, 800, 1800);
    pointLight.castShadow = true;
    scene.add(pointLight);

    const ambientLight = new THREE.AmbientLight(0x030303, 1000); // Add ambient light
    scene.add(ambientLight);

    const group = new THREE.Object3D();
    scene.add(group);

    for (let x = 0; x < xRows; x++) {
      cubes[x] = [];
      for (let z = 0; z < zRows; z++) {
        let cubeHeight = 100 + Math.random() * 1000;
        cubeHeight =
          10 +
          (Math.sin((x / xRows) * Math.PI) + Math.sin((z / zRows) * Math.PI)) *
            200 +
          Math.random() * 200;

        const geometry = new THREE.BoxGeometry(cubeSize, cubeHeight, cubeSize);

        var colours = [0x4444ff, 0x4477ff, 0x7744ff, 0xff8080];
        const material = new THREE.MeshPhongMaterial({
            color: colours[~~(Math.random() * colours.length)],
          // color: 0x4444ff,
          specular: 0xffffff,
          shininess: 10,
          flatShading: false, 
      
        });

        const cube = new THREE.Mesh(geometry, material);
        cube.position.x = halfXRows + x * cubeRow;
        cube.position.y = cubeHeight / 2;
        cube.position.z = (cubeRow * -zRows) / 2 + z * cubeRow;

        (cube as any).height = cubeHeight;
        group.add(cube);

        cubes[x][z] = cube;
      }
    }

    const renderer = new THREE.WebGLRenderer({antialias: true});
    renderer.setSize(stageWidth, stageHeight);
    
    if (containerRef.current) {
      containerRef.current.appendChild(renderer.domElement);
    }

    const position = { x: 0, y: 0, z: 0 };

    const checkRow = () => {
      const xIndex = position.x / cubeRow;
      const xLoops = Math.floor(xIndex / xRows);
      const zIndex = position.z / cubeRow;
      const zLoops = Math.floor(zIndex / zRows);

      for (let x = 0; x < xRows; x++) {
        for (let z = 0; z < zRows; z++) {
          let dx =
            x >= xIndex - xLoops * xRows
              ? xRows * (1 - xLoops)
              : xRows * (0 - xLoops);
          let dz =
            z >= zIndex - zLoops * zRows
              ? zRows * (1 - zLoops)
              : zRows * (0 - zLoops);

          cubes[x][z].position.x = (x - dx) * cubeRow - halfXRows;
          cubes[x][z].position.z = (z - dz) * cubeRow - halfZRows;

          let scale = (cubes[x][z].position.z + group.position.z) / 1500;
          if (scale < 1) scale = 1;
          scale = Math.pow(scale, 1.2);

          cubes[x][z].scale.y = scale;
          cubes[x][z].position.y = ((cubes[x][z] as any).height * scale) / 2;
        }
      }
    };

    const camPos = new THREE.Vector3(0, 0, 0);

    const render = (t: number) => {
      if (isRunning) requestAnimationFrame(render);

      position.x += Math.sin(t * 0.001) * 20;
      position.z += (Math.cos(t * 0.0008) + 5) * 20;
      group.position.x = -position.x;
      group.position.z = -position.z;

      checkRow();

      camera.position.x = Math.sin(t * 0.0003) * 1000;
      camera.position.z = -4000;
      camera.position.y = (Math.cos(t * 0.0004) + 1.3) * 3000;
      camera.lookAt(camPos);

      renderer.render(scene, camera);
    };
    render(0);

    return () => {
      isRunning = false;
      if (containerRef.current) {
        containerRef.current.removeChild(renderer.domElement);
      }
    };
  }, []);

  return <div className={props.className} ref={containerRef} />;
};

export default HomeBackground;
